import { Network } from "@/network";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Log } from "@/util";

class StoreModel {
    private static sInstance: StoreModel;

    public static get instance(): StoreModel {
        if (!StoreModel.sInstance) {
            StoreModel.sInstance = new StoreModel();
        }

        return StoreModel.sInstance;
    }

    private storeList = TCBReceiptApi.Protobuf.StoreList.create();
    private specificStore = TCBReceiptApi.Protobuf.Store.create();

    public async getStoreSearch(storeUserQuery: Uint8Array): Promise<void> {
        await Network.sendAPI("/api/front/store_user/get_search", "post", storeUserQuery)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.storeList = TCBReceiptApi.Protobuf.StoreList.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch(error => {
                Log.error(error);
            });
    }

    public async getStore(storeInsertQuery: Uint8Array): Promise<void> {
        await Network.sendAPI("/api/front/store_user/get", "post", storeInsertQuery)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.storeList = TCBReceiptApi.Protobuf.StoreList.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch(error => {
                Log.error(error);
            });
    }

    public async getStoreByCondition(
        storeInsertQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/store_user/get_by_condition",
            "post",
            storeInsertQuery
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.storeList = TCBReceiptApi.Protobuf.StoreList.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch(error => {
                Log.error(error);
            });
    }

    public async getStoreByStoreID(storeQuery: Uint8Array): Promise<void> {
        await Network.sendAPI("/api/front/store_user/get_by_store_id", "post", storeQuery)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.specificStore = TCBReceiptApi.Protobuf.Store.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch(error => {
                Log.error(error);
            });
    }

    public async editStore(store: Uint8Array): Promise<number> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI("/api/front/store_user/edit", "post", store)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public async exportCurrent(storeQuery: Uint8Array): Promise<void> {
        await Network.downloadFile("/api/front/store_user/export_current", storeQuery);
    }

    public getStoreInsertList(): TCBReceiptApi.Protobuf.StoreList {
        return this.storeList;
    }

    public getStoreList(): TCBReceiptApi.Protobuf.StoreList {
        return this.storeList;
    }

    public getSpecificStore(): TCBReceiptApi.Protobuf.Store {
        return this.specificStore;
    }
}

const storeModel = StoreModel.instance;

export { storeModel as StoreModel };
